import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-ausbildung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')